module.exports = __webpack_public_path__ + "static/media/DeleteAccountLogo.8ca65cb7.svg";